<template>
  <div class="layout-builder-layout-placeholder-sessions">
    <div
      v-for="i in PLACEHOLDER_SAMPLES"
      :key="i"
      class="layout-builder-layout-placeholder-sessions-row"
    >
      <div class="layout-builder-layout-placeholder-sessions-row-avatar" />
      <div class="layout-builder-layout-placeholder-sessions-row-line" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'LayoutBuilderLayoutPlaceholderSessions',
  setup() {
    const PLACEHOLDER_SAMPLES = 50;

    return {
      PLACEHOLDER_SAMPLES,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../styles/index";

.layout-builder-layout-placeholder-sessions {
  @include placeholder;

  gap: var(--s-4);

  &-row {
    align-items: center;
    gap: var(--s-3);

    &-avatar {
      @include placeholder-circle;

      width: 3rem;
      height: 3rem;
    }

    &-line {
      @include placeholder-line-primary;

      flex: 1;
    }
  }
}
</style>
